import { render, staticRenderFns } from "./addService.vue?vue&type=template&id=6b19b460&scoped=true&"
import script from "./addService.vue?vue&type=script&lang=js&"
export * from "./addService.vue?vue&type=script&lang=js&"
import style0 from "./addService.vue?vue&type=style&index=0&lang=scss&"
import style1 from "./addService.vue?vue&type=style&index=1&id=6b19b460&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6b19b460",
  null
  
)

component.options.__file = "addService.vue"
export default component.exports